import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { BetType } from '@bpos/common';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';

import { MyBetsRaceBetType } from '../../../my-bets-base/models/my-bets-response';
import { MyBetsBet } from '../../../my-bets-base/models/my-bets-viewmodels';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ms-my-bets-betslip-market-name',
    styleUrl: 'my-bets-betslip-market-name.component.scss',
    template: ` <div class="mybets-betslip-info_market-name">{{ marketName }}</div> `,
})
export class MyBetsBetslipMarketNameComponent {
    constructor(private sitecore: Sitecore) {}

    @Input() bet: MyBetsBet;

    get marketName(): string {
        if (this.bet.participantInfo) {
            // participant bet.
            switch (this.bet.sportId) {
                case SportConstant.Horses: {
                    return this.bet.betTypeName;
                }
                case SportConstant.Golf: {
                    if (this.bet.participantInfo.betType === MyBetsRaceBetType.EachWay) {
                        return `${this.bet.marketName} ${this.bet.betTypeName}`;
                    } else {
                        return this.bet.marketName;
                    }
                }
                default: {
                    return this.bet.marketName;
                }
            }
        }

        if (this.bet.isPriceBoosted) {
            return `${this.bet.marketName} - ${this.sitecore.event.PriceBoostMarket}`;
        }

        if (
            this.bet.optionMarketInfo &&
            (this.bet.betType === BetType.EachWay ||
                this.bet.betType === BetType.Forecast ||
                this.bet.betType === BetType.Tricast ||
                this.bet.betType === BetType.CombinationForecast ||
                this.bet.betType === BetType.CombinationTricast)
        ) {
            return this.bet.betTypeName;
        }
        return this.bet.marketName;
    }
}
